<script>
import { Icon } from '~/ui/elements'

export default {
  name: 'EmptyState',
  components: {
    Icon
  },
  props: {
    dense: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    buttonText: {
      type: String,
      default: null
    },
    icon: {
      type: Object,
      default: null
    }
  },
  computed: {
    style: vm => ({
      class: `d-flex align-center justify-center flex-wrap ${vm.dense ? 'py-2' : 'py-16'}`,
      ...!vm.dense && { height: '60vh' }
    })
  }
}
</script>

<template>
  <VSheet
    v-bind="style"
    width="100%"
  >
    <div class="text-center">
      <Icon
        :src="icon"
        width="50"
      />
      <h4 class="text-h6 pt-1">
        {{ message }}
      </h4>
      <h5
        v-if="description"
        class="text-subtitle-1 text-grey-darken-1"
      >
        {{ description }}
      </h5>
      <VBtn
        v-if="buttonText"
        class="mt-6 text-capitalize"
        color="primary"
        rounded
        @click="$emit('action')"
      >
        {{ buttonText }}
      </VBtn>
    </div>
  </VSheet>
</template>
